// extracted by mini-css-extract-plugin
export default {"wrapper":"ActionBanner_wrapper__eJSkV","leftRightPart":"ActionBanner_leftRightPart__VaCVg"};